import { __decorate } from "tslib";
// NPM
import PageHeader from "@/components/page-header.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Layout from "@/router/layouts/main.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins } from "vue-property-decorator";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EmptyProviderComponent = /** @class */ (() => {
    let EmptyProviderComponent = class EmptyProviderComponent extends Mixins(BaseMixer) {
        created() { }
    };
    EmptyProviderComponent = __decorate([
        Component({
            name: "EmptyProviderComponent",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
            },
        })
    ], EmptyProviderComponent);
    return EmptyProviderComponent;
})();
export default EmptyProviderComponent;
